import { useMeeting } from '@videosdk.live/react-sdk';
import { Col, Row } from 'antd';
import { memo, useCallback, useEffect } from 'react';
import ParticipantView from './ParticipantView';

const MeetingGrid = ({ meetingId, leaveRoom }) => {
  // const [joined, setJoined] = useState(false);
  const { join, leave, toggleScreenShare } = useMeeting();
  const { participants } = useMeeting();

  const chunk = useCallback((arr) => {
    const newArr = [];
    while (arr.length) newArr.push(arr.splice(0, 3));
    return newArr;
  }, []);

  // const joinMeeting = useCallback(() => {
  //   setJoined(true);
  //   join();
  // }, [join]);

  useEffect(() => {
    setTimeout(() => {
      join();
    }, 1000);

    return () => {
      leave();
      leaveRoom();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ padding: '20px', minHeight: '100vh' }}>
      <header>Meeting Id: {meetingId}</header>
      {/* {joined ? ( */}
      <div>
        <button
          onClick={() => {
            leave();
            leaveRoom();
          }}
        >
          Leave
        </button>
        {/* <button onClick={toggleMic}>toggleMic</button>
          <button onClick={toggleWebcam}>toggleWebcam</button> */}
        <button onClick={toggleScreenShare}>Screen Share</button>
      </div>
      {/* ) : (
        <button onClick={joinMeeting}>Join</button>
      )} */}
      <div>
        {chunk([...participants.keys()]).map((k) => (
          <Row key={k} gutter={[8, 16]}>
            {k.map((l) => (
              <Col span={4} key={k + l}>
                <ParticipantView participantId={l} />
              </Col>
            ))}
          </Row>
        ))}
      </div>
    </div>
  );
};
export default memo(MeetingGrid);
